import React, { useEffect, useState } from "react";
import verifyarrow from "../assets/images/icons/verify-arrow.svg";
import profileimg from "../assets/profile.png";
import pipaanlogo from "../assets/pipaanlogo.svg";
import closecircle from "../assets/images/icons/close-circle.png";
import businessbadge from "../assets/images/icons/Business-badge.svg";
import Individualbadge from "../assets/images/icons/Individual-badge.svg";
import influencerbadge from "../assets/images/icons/influencer-badge.svg";
import { IoCloseCircle } from "react-icons/io5";
import axios from "axios";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const ALLOWED_DOCUMENT_TYPES = ["application/pdf", "image/jpeg", "image/png"];
const VerificationModal = ({
  isOpen,
  onClose,
  userData,
  getverified,
  isEligible,
  fetchVerificationStatus,
  isInfluencer,
  influencerStatus,
}) => {
  console.log("userData=====>", userData);
  const [isFormView, setIsFormView] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // ✅ Stripe
  const stripe = useStripe();
  const elements = useElements();

  // Define account types
  const isBusinessAccount = userData?.account_type === "business";
  const isInfluencerAccount = isInfluencer;
  const isIndividualAccount =
    !isInfluencer && userData?.account_type === "individual";

  // State for files
  const [files, setFiles] = useState({
    companyRegistrationCert: null,
    taxCertificate: null,
    moaBoardResolution: null,
    boardResolution: null,
    governmentId: null,
    mediaLink1: null,
    mediaLink2: null,
    mediaLink3: null,
  });

  // State for form inputs
  const [governmentIdType, setGovernmentIdType] = useState("passport");
  const [einNumber, setEinNumber] = useState("");
  const [mediaLinkUrl1, setMediaLinkUrl1] = useState("");
  const [mediaLinkUrl2, setMediaLinkUrl2] = useState("");
  const [mediaLinkUrl3, setMediaLinkUrl3] = useState("");

  // ✅ Business: documents first -> payment step
  const [businessStep, setBusinessStep] = useState(1); // 1=docs, 2=payment
  const [businessDocPayload, setBusinessDocPayload] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState("");
  const [businessPaymentSuccess, setBusinessPaymentSuccess] = useState(false);
  const [businessPaymentFailed, setBusinessPaymentFailed] = useState(false);
  const [savedCard] = useState(null);

  // ✅ Receipt UI data (for business success/fail)
  const [businessPaymentReceipt, setBusinessPaymentReceipt] = useState({
    orderNo: "",
    paymentRefNo: "",
    senderName: "",
    paymentMethod: "",
    amount: "",
    dateTime: "",
  });
  // Fee comes from the business VerificationConfig; a user who already paid (lifetime) only resubmits documents
  const [businessOverview, setBusinessOverview] = useState(null);
  const isBusinessFlow = !isInfluencer && userData?.account_type === "business";

  useEffect(() => {
    if (!isOpen || !isBusinessFlow) return;
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    axios
      .get(`${API_BASE_URL}/verification/business/overview`, { headers: { token } })
      .then((res) => setBusinessOverview(res.data?.success ? res.data.result : null))
      .catch(() => setBusinessOverview(null));
  }, [isOpen, isBusinessFlow]);

  const CURRENCY_SYMBOLS = { usd: "$", inr: "₹", eur: "€", gbp: "£" };
  const businessFee = businessOverview
    ? `${CURRENCY_SYMBOLS[businessOverview.currency?.toLowerCase()] || "$"}${Number(businessOverview.fee || 0).toFixed(2)}`
    : "...";

  if (!isOpen) return null;

  const handleFileChange = (key, file) => {
    if (!file) return;
    if (!ALLOWED_DOCUMENT_TYPES.includes(file.type)) {
      setSubmitError(
        `"${file.name}" is not a supported file. Please upload a PDF, JPG or PNG document.`
      );
      return;
    }
    setSubmitError("");
    setFiles((prev) => ({ ...prev, [key]: file }));
  };

  const removeFile = (key) => {
    setFiles((prev) => ({ ...prev, [key]: null }));
  };

  // Check for minimum followers
  const minRequired = 1;
  const hasMinFollowers = isEligible;

  const handleApplyClick = () => {
    if (hasMinFollowers || userData?.account_type === "business") {
      setIsFormView(true);
    }
  };

  // Function to upload file and get URL
  const uploadFileAndGetUrl = async (file) => {
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      // Step 1: Generate pre-signed URL
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        {
          files: [
            {
              fileName: file.name,
              fileType: file.type,
            },
          ],
        },
        {
          headers: {
            token: token,
          },
        }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URL");
      }

      const preSignedUrl = response.data.directory[0].presignedUrl;
      const fileUrl = response.data.directory[0].fileUrl;

      // Step 2: Upload file to S3
      await axios.put(preSignedUrl, file, {
        headers: {
          "Content-Type": file.type,
          "Content-Encoding": "binary",
        },
      });

      return fileUrl;
    } catch (error) {
      console.error("Upload error:", error);
      throw new Error(
        error.response?.data?.message || error.message || "Failed to upload file"
      );
    }
  };

  // Handle individual verification submission
  const handleIndividualVerification = async () => {
    if (!files.governmentId) {
      setSubmitError("Please upload a government ID");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      // Upload government ID file
      const governmentIdUrl = await uploadFileAndGetUrl(files.governmentId);

      // Submit verification request
      const response = await axios.post(
        `${API_BASE_URL}/verification/individual`,
        {
          government_id_type: governmentIdType,
          government_id_url: governmentIdUrl,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setSubmitSuccess(true);
        setTimeout(() => {
          getverified(false);
          setIsFormView(false);
          setSubmitSuccess(false);
        }, 2000);
        fetchVerificationStatus();
      } else {
        setSubmitError(
          response.data.message || "Verification submission failed"
        );
      }
    } catch (error) {
      console.error("Verification error:", error);
      setSubmitError(
        error.response?.data?.message || "An error occurred during verification"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ Business docs submit first then payment UI
  const handleBusinessDocumentsFirst = async () => {
    if (!einNumber) return setSubmitError("Please enter EIN Number");
    if (!/^\d{2}-\d{7}$/.test(einNumber))
      return setSubmitError("EIN Number must be in the format XX-XXXXXXX (9 digits)");
    if (!files.companyRegistrationCert)
      return setSubmitError("Please upload Company Registration Certificate");
    if (!files.taxCertificate)
      return setSubmitError("Please upload Tax Certificate");
    if (!files.moaBoardResolution)
      return setSubmitError("Please upload MOA Resolution");
    if (!files.boardResolution)
      return setSubmitError("Please upload Board Resolution");

    setIsSubmitting(true);
    setSubmitError("");

    try {
      const [companyRegistrationUrl, taxCertificateUrl, moaBoardResolutionUrl] =
        await Promise.all([
          uploadFileAndGetUrl(files.companyRegistrationCert),
          uploadFileAndGetUrl(files.taxCertificate),
          uploadFileAndGetUrl(files.moaBoardResolution),
        ]);

      const payload = {
        ein_number: einNumber,
        company_registration_certificate: {
          url: companyRegistrationUrl,
          media_type: files.companyRegistrationCert.type,
        },
        tax_certificate: {
          url: taxCertificateUrl,
          media_type: files.taxCertificate.type,
        },
        moa_board_resolution: {
          url: moaBoardResolutionUrl,
          media_type: files.moaBoardResolution.type,
        },
      };

      setBusinessDocPayload(payload);

      setBusinessStep(2);
      setBusinessPaymentFailed(false);
      setBusinessPaymentSuccess(false);
      setSubmitError("");
    } catch (error) {
      console.error("Business documents upload error:", error);
      setSubmitError(
        error.response?.data?.message ||
          error.message ||
          "Failed to upload business documents"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ Final business submit after payment success
  const handleFinalBusinessVerification = async (intentId) => {
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      const verificationResponse = await axios.post(
        `${API_BASE_URL}/verification/business/documents`,
        businessDocPayload,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (verificationResponse.data.success) {
        setSubmitSuccess(true);
        fetchVerificationStatus();
      } else {
        setSubmitError(
          verificationResponse.data.message ||
            "Business verification submission failed"
        );
      }
    } catch (error) {
      console.error("Business final submit error:", error);
      setSubmitError(
        error.response?.data?.message ||
          error.message ||
          "An error occurred during business verification"
      );
    }
  };

  const handleBusinessPayment = async () => {
    if (!businessDocPayload) {
      setSubmitError("Please submit business documents first.");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");
    setBusinessPaymentFailed(false);

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      // ✅ Step 1: INIT PAYMENT (get intent + client_secret)
      const paymentResponse = await axios.post(
        `${API_BASE_URL}/verification/business/payment`,
        {},
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!paymentResponse.data.success) {
        throw new Error(
          paymentResponse.data.message || "Payment initialization failed"
        );
      }

      const paymentResult = paymentResponse.data.result || {};

      // Already paid (the fee is one-time): there is no new intent, only the documents are submitted
      if (paymentResult.payment_status === "completed") {
        await handleFinalBusinessVerification();
        return;
      }

      if (!stripe || !elements) {
        throw new Error("Stripe is not ready. Please try again.");
      }

      const paymentIntentIdFromApi = paymentResult.payment_intent_id;
      const clientSecret = paymentResult.client_secret;

      if (!paymentIntentIdFromApi)
        throw new Error("payment_intent_id not received");
      if (!clientSecret) throw new Error("client_secret not received");

      // ✅ Step 2: STRIPE CONFIRM (this is actual payment)
      const card = elements.getElement(CardElement);

      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card,
            billing_details: {
              name:
                `${userData?.first_name || ""} ${
                  userData?.last_name || ""
                }`.trim() || "Nyawoo User",
            },
          },
        }
      );

      if (error) {
        throw new Error(error.message);
      }

      if (paymentIntent?.status !== "succeeded") {
        throw new Error(
          `Payment not successful. Status: ${paymentIntent?.status}`
        );
      }

      // ✅ Step 3: CONFIRM PAYMENT WITH BACKEND
      const confirmResponse = await axios.post(
        `${API_BASE_URL}/verification/business/payment/confirm`,
        {
          payment_intent_id: paymentIntentIdFromApi,
        },
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!confirmResponse.data.success) {
        throw new Error(
          confirmResponse.data.message || "Payment confirmation failed"
        );
      }

      // ✅ Payment complete
      setPaymentIntentId(paymentIntentIdFromApi);
      setBusinessPaymentSuccess(true);

      setBusinessPaymentReceipt({
        orderNo: paymentIntentIdFromApi?.slice(-8) || "125686246",
        paymentRefNo: paymentIntentIdFromApi?.slice(-9) || "123586954",
        senderName:
          `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim() ||
          "N/A",
        paymentMethod: "Credit Card",
        amount: Number(paymentResult.amount || 0).toFixed(2),
        dateTime: new Date().toLocaleString("en-US"),
      });

      // ✅ submit docs final
      await handleFinalBusinessVerification(paymentIntentIdFromApi);
    } catch (error) {
      console.error("Business payment error:", error);

      setBusinessPaymentFailed(true);
      setBusinessPaymentSuccess(false);

      setBusinessPaymentReceipt((prev) => ({
        ...prev,
        paymentRefNo: "Failed",
        senderName:
          `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim() ||
          "N/A",
        paymentMethod: "Credit Card",
        amount: businessOverview ? Number(businessOverview.fee || 0).toFixed(2) : "",
        dateTime: new Date().toLocaleString("en-US"),
      }));

      setSubmitError(
        error.response?.data?.message ||
          error.message ||
          "An error occurred during business payment"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle influencer verification submission
  const handleInfluencerVerification = async () => {
    const links = [mediaLinkUrl1, mediaLinkUrl2, mediaLinkUrl3].map((l) =>
      (l || "").trim()
    );
    if (links.some((l) => !l)) {
      setSubmitError("Please provide all three media links");
      return;
    }
    const invalidIndex = links.findIndex((l) => !/^https?:\/\/[^\s.]+\.\S+$/i.test(l));
    if (invalidIndex !== -1) {
      setSubmitError(
        `Media link ${invalidIndex + 1} must be a valid URL (starting with http:// or https://)`
      );
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      const response = await axios.post(
        `${API_BASE_URL}/verification/influencer`,
        {
          media_link_1: links[0],
          media_link_2: links[1],
          media_link_3: links[2],
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setSubmitSuccess(true);
        setTimeout(() => {
          getverified(false);
          setIsFormView(false);
          setSubmitSuccess(false);
        }, 2000);
        fetchVerificationStatus();
      } else {
        setSubmitError(
          response.data.message || "Influencer verification submission failed"
        );
      }
    } catch (error) {
      console.error("Influencer verification error:", error);
      setSubmitError(
        error.response?.data?.message ||
          "An error occurred during influencer verification"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isIndividualAccount) {
      await handleIndividualVerification();
    } else if (isBusinessAccount) {
      return;
    } else if (isInfluencerAccount) {
      await handleInfluencerVerification();
    }
  };

  // UploadField component
  const UploadField = ({ label, placeholder, file, onChange, onRemove }) => (
    <div className="">
      <label className="text-[14px] font-medium">{label}</label>

      <label className="mt-2 flex justify-between items-center h-[56px] px-4 border border-[#095228] rounded-xl cursor-pointer">
        <span className="text-gray-400 text-[14px]">{placeholder}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095228"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <input
          type="file"
          hidden
          accept={ALLOWED_DOCUMENT_TYPES.join(",")}
          onChange={(e) => {
            onChange(e.target.files[0]);
            e.target.value = "";
          }}
        />
      </label>

      {file && (
        <div className="mt-2 flex items-center gap-2">
          <span className="text-[#4C6FFF] italic text-md">{file.name}</span>
          <IoCloseCircle
            className="text-red-500 cursor-pointer"
            onClick={onRemove}
          />
        </div>
      )}
    </div>
  );

  // ✅ Business Success UI
  const BusinessPaymentSuccessUI = () => (
    <div className="w-full flex flex-col items-center justify-center py-10">
      <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center mb-6">
        <div className="w-16 h-16 rounded-full bg-green-500 flex items-center justify-center">
          <span className="text-white text-3xl font-bold">✓</span>
        </div>
      </div>

      <h3 className="text-xl font-semibold text-center mb-6">
        Your verification request has been submitted.
      </h3>

      <p className="text-sm text-gray-500">Total Payment</p>
      <p className="text-4xl font-bold mb-2">
        ${businessPaymentReceipt.amount}
      </p>
      <p className="text-xs text-gray-500 mb-8">
        {businessPaymentReceipt.dateTime}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl mb-10">
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Order No</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.orderNo}
          </p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Payment Ref No.</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.paymentRefNo}
          </p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Sender Name</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.senderName}
          </p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Payment Method</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.paymentMethod}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => {
          getverified(false);
          setIsFormView(false);
          setSubmitSuccess(false);
          setBusinessStep(1);
          setBusinessPaymentSuccess(false);
          setBusinessPaymentFailed(false);
        }}
        className="w-full max-w-[360px] bg-[#095228] text-white py-3 rounded-full font-medium hover:opacity-90"
      >
        View Verification Status
      </button>
    </div>
  );

  // ✅ Business Failed UI
  const BusinessPaymentFailedUI = () => (
    <div className="w-full flex flex-col items-center justify-center py-10">
      <div className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mb-6">
        <div className="w-16 h-16 rounded-full bg-[#B91C1C] flex items-center justify-center">
          <span className="text-white text-3xl font-bold">✕</span>
        </div>
      </div>

      <h3 className="text-xl font-bold text-[#B91C1C] text-center mb-2">
        Payment Failed
      </h3>
      <p className="text-sm text-gray-500 text-center mb-6">
        Unfortunately, we couldn't process your payment.
      </p>

      <p className="text-sm text-gray-500">Total Payment</p>
      <p className="text-4xl font-bold mb-2">
        ${businessPaymentReceipt.amount}
      </p>
      <p className="text-xs text-gray-500 mb-8">
        {businessPaymentReceipt.dateTime}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl mb-10">
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Order No</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.orderNo}
          </p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Payment Ref No.</p>
          <p className="text-sm font-semibold text-[#B91C1C]">Failed</p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Sender Name</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.senderName}
          </p>
        </div>
        <div className="border rounded-lg p-4">
          <p className="text-xs text-gray-500">Payment Method</p>
          <p className="text-sm font-semibold">
            {businessPaymentReceipt.paymentMethod}
          </p>
        </div>
      </div>

      <button
        type="button"
        disabled={isSubmitting}
        onClick={() => {
          setBusinessPaymentFailed(false);
          setSubmitError("");
        }}
        className="w-full max-w-[240px] bg-[#B91C1C] text-white py-3 rounded-full font-medium hover:opacity-90 disabled:opacity-50"
      >
        {isSubmitting ? "Retrying..." : "Retry Payment"}
      </button>
    </div>
  );

  return (
    <div>
      <div className="get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md z-50">
        <div className="border-popup bg-white rounded-lg relative max-w-3xl w-full mx-4">
          <div className="flex justify-between p-6 border-b">
            <div className="logo-popup flex items-center justify-center space-x-2">
              <img src={pipaanlogo} alt="Nyawoo Logo" className="w-40" />
            </div>
            <button
              onClick={() => {
                getverified(false);
                setIsFormView(false);
                setSubmitError("");
                setSubmitSuccess(false);
                setBusinessPaymentFailed(false);
              }}
              className="focus:outline-none"
            >
              <img src={closecircle} alt="close" className="w-8 h-8" />
            </button>
          </div>

          <div className="p-6">
            <h2 className="text-[#000000] text-[32px] font-semibold">
              Get Verified on Nyawoo
            </h2>
          </div>

          <hr className="border-[#D9D9D9]"></hr>

          <div className="p-6">
            <div className="relative w-full">
              <div className="flex flex-wrap items-center w-full justify-between gap-x-6 gap-y-5 mb-10">
                <div className="flex items-start min-w-0">
                  <div className="w-20 h-20 flex-none rounded-full overflow-hidden border-2 border-gray-200">
                    <img
                      src={userData?.profile_picture_url || profileimg}
                      alt="Profile"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="pl-4 flex flex-col min-w-0">
                    <div className="flex items-center gap-4">
                      <p className="font-semibold text-[20px] break-words">
                        {isBusinessAccount
                          ? userData?.business_name || "N/A"
                          : `${userData?.first_name || ""} ${
                              userData?.last_name || "N/A"
                            }`}
                      </p>
                    </div>
                    <p className="text-sm text-[#747474]">
                      @{userData?.username || "N/A"}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      <p className="text-sm text-[#095228] font-semibold">
                        {userData?.followersCount || 0} Followers
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 min-w-0">
                  <img
                    src={
                      isBusinessAccount
                        ? businessbadge
                        : isInfluencerAccount
                        ? influencerbadge
                        : Individualbadge
                    }
                    className="w-10 h-10 flex-none"
                    alt="Account Badge"
                  />
                  <div className="flex flex-col gap-1 items-start">
                    <h2 className="text-md text-[#000000] font-semibold">
                      {isFormView
                        ? isBusinessAccount
                          ? "Business Verification"
                          : isInfluencerAccount
                          ? "Influencer Verification"
                          : "Individual Verification"
                        : "Get Verified on Nyawoo"}
                    </h2>
                    <p className="text-sm text-[#747474]">
                      (If Business + 10K followers)
                    </p>
                  </div>
                </div>
              </div>

              {!isFormView &&
              isInfluencerAccount &&
              ["under_review", "approved"].includes(influencerStatus?.status) ? (
                <div className="mt-10 p-5 rounded-xl border border-[#095228] max-w-[450px]">
                  <p className="text-sm text-[#747474]">Verification Status</p>
                  <p
                    className={`text-lg font-semibold mt-1 ${
                      influencerStatus.status === "approved"
                        ? "text-green-700"
                        : "text-yellow-700"
                    }`}
                  >
                    {influencerStatus.status === "approved"
                      ? "Approved - You are a verified influencer"
                      : "Under Review"}
                  </p>
                  {influencerStatus.submittedAt && (
                    <p className="text-sm text-gray-600 mt-2">
                      Submitted on{" "}
                      {new Date(influencerStatus.submittedAt).toLocaleDateString("en-US")}
                    </p>
                  )}
                  {influencerStatus.status === "under_review" && (
                    <p className="text-sm text-gray-600 mt-1">
                      Your request is being reviewed. We will notify you once it is processed.
                    </p>
                  )}
                </div>
              ) : !isFormView ? (
                <div className="flex flex-col items-start mt-10">
                  {isInfluencerAccount && influencerStatus?.status === "rejected" && (
                    <div className="mb-4 p-4 rounded-xl bg-red-50 border border-red-200 text-red-700 max-w-[450px]">
                      <p className="font-semibold">Your previous request was rejected</p>
                      {influencerStatus.rejectionReason && (
                        <p className="text-sm mt-1">
                          Reason: {influencerStatus.rejectionReason}
                        </p>
                      )}
                      <p className="text-sm mt-1">You can apply again below.</p>
                    </div>
                  )}
                  <button
                    onClick={handleApplyClick}
                    disabled={
                      !hasMinFollowers && userData?.account_type !== "business"
                    }
                    style={{
                      backgroundColor:
                        hasMinFollowers || userData?.account_type === "business"
                          ? "#095228"
                          : "#747474",
                    }}
                    className="w-full max-w-[350px] text-white text-md py-3 px-6 rounded-full flex items-center justify-between transition-colors duration-300 hover:opacity-90"
                  >
                    Apply for Verification
                    <img src={verifyarrow} className="w-6 h-6" alt="arrow" />
                  </button>

                  {!hasMinFollowers &&
                    userData?.account_type !== "business" && (
                      <p className="text-[#BE1F2E] text-sm mt-3 font-medium">
                        *Minimum 10,000 followers required
                      </p>
                    )}
                </div>
              ) : (
                <div className="mt-8">
                  {/* ✅ Business payment fail/success UI */}
                  {isBusinessAccount && businessPaymentFailed ? (
                    <BusinessPaymentFailedUI />
                  ) : isBusinessAccount &&
                    businessPaymentSuccess &&
                    submitSuccess ? (
                    <BusinessPaymentSuccessUI />
                  ) : submitSuccess ? (
                    <div className="text-center py-10">
                      <div className="text-green-600 text-5xl mb-4">✓</div>
                      <h3 className="text-2xl font-semibold text-green-700 mb-2">
                        Verification Submitted!
                      </h3>
                      <p className="text-gray-600">
                        Your verification request has been submitted
                        successfully.
                      </p>
                      <p className="text-gray-600">
                        We will review your documents and notify you soon.
                      </p>
                    </div>
                  ) : (
                    <>
                      <h2 className="text-2xl font-semibold mb-6">
                        {isBusinessAccount
                          ? "Business Verification"
                          : isInfluencerAccount
                          ? "Influencer Verification"
                          : "Individual Verification"}
                      </h2>

                      <form onSubmit={handleSubmit} className="space-y-6">
                        {submitError && (
                          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                            {submitError}
                          </div>
                        )}

                        {isIndividualAccount ? (
                          <div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                              <UploadField
                                label="Government ID Document"
                                placeholder="Upload government ID"
                                file={files.governmentId}
                                onChange={(f) =>
                                  handleFileChange("governmentId", f)
                                }
                                onRemove={() => removeFile("governmentId")}
                              />
                            </div>

                            <div className="flex flex-col md:flex-row justify-between items-center pt-6 gap-4">
                              <button
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                  backgroundColor: isSubmitting
                                    ? "#747474"
                                    : "#095228",
                                }}
                                className="w-full md:w-auto md:min-w-[350px] text-white text-md py-3 px-6 rounded-full flex items-center justify-between transition-colors duration-300 hover:opacity-90 disabled:opacity-50"
                              >
                                {isSubmitting
                                  ? "Submitting..."
                                  : "Submit Verification"}
                                <img
                                  src={verifyarrow}
                                  className="w-6 h-6"
                                  alt="arrow"
                                />
                              </button>

                              <button
                                type="button"
                                onClick={() => setIsFormView(false)}
                                className="text-gray-500 text-sm hover:text-gray-700"
                              >
                                Go Back
                              </button>
                            </div>
                          </div>
                        ) : isBusinessAccount ? (
                          <div className="space-y-8">
                            {businessStep === 1 ? (
                              <>
                                {/* ✅ Step 1: Business Documents */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-5">
                                  <div>
                                    <label className="text-[14px] font-medium">
                                      EIN No
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Enter EIN Number"
                                      value={einNumber}
                                      onChange={(e) =>
                                        setEinNumber(e.target.value)
                                      }
                                      className="mt-2 w-full h-[56px] px-4 border border-[#095228] rounded-xl text-[14px]"
                                    />
                                  </div>

                                  <UploadField
                                    label="Company Registration Certificate"
                                    placeholder="Upload Company Registration Certificate"
                                    file={files.companyRegistrationCert}
                                    onChange={(f) =>
                                      handleFileChange(
                                        "companyRegistrationCert",
                                        f
                                      )
                                    }
                                    onRemove={() =>
                                      removeFile("companyRegistrationCert")
                                    }
                                  />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-5">
                                  <UploadField
                                    label="Tax Certificate"
                                    placeholder="Upload Tax Certificate"
                                    file={files.taxCertificate}
                                    onChange={(f) =>
                                      handleFileChange("taxCertificate", f)
                                    }
                                    onRemove={() =>
                                      removeFile("taxCertificate")
                                    }
                                  />

                                  <UploadField
                                    label="MOA"
                                    placeholder="Upload MOA"
                                    file={files.moaBoardResolution}
                                    onChange={(f) =>
                                      handleFileChange("moaBoardResolution", f)
                                    }
                                    onRemove={() =>
                                      removeFile("moaBoardResolution")
                                    }
                                  />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-5">
                                  <UploadField
                                    label="Board Resolution"
                                    placeholder="Board Resolution"
                                    file={files.boardResolution}
                                    onChange={(f) =>
                                      handleFileChange("boardResolution", f)
                                    }
                                    onRemove={() =>
                                      removeFile("boardResolution")
                                    }
                                  />
                                </div>

                                <div className="flex justify-between items-center pt-6">
                                  <button
                                    type="button"
                                    disabled={isSubmitting}
                                    style={{
                                      backgroundColor: isSubmitting
                                        ? "#747474"
                                        : "#095228",
                                    }}
                                    onClick={handleBusinessDocumentsFirst}
                                    className="w-full max-w-[350px] text-white text-md py-3 px-6 rounded-full flex items-center justify-between transition-colors duration-300 hover:opacity-90 disabled:opacity-50"
                                  >
                                    {isSubmitting
                                      ? "Uploading..."
                                      : "Continue to Payment"}
                                    <img
                                      src={verifyarrow}
                                      className="w-6 h-6"
                                      alt="arrow"
                                    />
                                  </button>

                                  <div className="text-left">
                                    <div className="flex items-start items-end gap-2">
                                      <p className="text-3xl font-bold">
                                        {businessFee}
                                      </p>
                                      <p className="text-sm text-[#000000] font-bold">
                                        One-Time Verification Fee
                                      </p>
                                    </div>
                                    <p className="text-md text-[#000000]">
                                      *Includes annual verification check
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                {/* ✅ Step 2: Payment UI */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                  <div className="bg-[#F4F5F7] rounded-2xl p-5">
                                    <div className="flex items-center justify-between mb-4">
                                      <h4 className="font-semibold text-[#111827]">
                                        Saved Cards
                                      </h4>
                                      <div className="w-7 h-7 rounded-full bg-[#D1D5DB] flex items-center justify-center">
                                        <span className="text-xs">↑</span>
                                      </div>
                                    </div>

                                    {savedCard && (
                                      <div className="bg-white rounded-xl p-4 border border-[#E5E7EB] mb-3">
                                        <p className="text-sm font-semibold">
                                          {savedCard.brand}: {savedCard.last4}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                          Exp. date: {savedCard.expiry}
                                        </p>
                                      </div>
                                    )}

                                    <div className="bg-white rounded-xl p-4 border border-[#095228]">
                                      <p className="text-sm font-semibold mb-2">
                                        Pay with Card
                                      </p>

                                      <div className="h-[56px] px-4 border border-[#095228] rounded-xl flex items-center">
                                        <div className="w-full">
                                          <CardElement
                                            options={{
                                              hidePostalCode: true,
                                              style: {
                                                base: {
                                                  fontSize: "14px",
                                                  color: "#111827",
                                                  "::placeholder": {
                                                    color: "#9CA3AF",
                                                  },
                                                },
                                                invalid: { color: "#BE1F2E" },
                                              },
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <button
                                        type="button"
                                        disabled={
                                          isSubmitting ||
                                          (!businessOverview?.hasPaid && (!stripe || !elements))
                                        }
                                        onClick={handleBusinessPayment}
                                        className="mt-4 w-full bg-[#095228] text-white py-3 rounded-full font-medium hover:opacity-90 disabled:opacity-50"
                                      >
                                        {isSubmitting
                                          ? "Processing..."
                                          : businessOverview?.hasPaid
                                          ? "Submit for Review →"
                                          : "Pay Now →"}
                                      </button>

                                      <button
                                        type="button"
                                        onClick={() => setBusinessStep(1)}
                                        className="mt-3 text-sm text-gray-500 hover:text-gray-800"
                                      >
                                        ← Back to Documents
                                      </button>
                                    </div>
                                  </div>

                                  <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
                                    <h3 className="text-xl font-semibold mb-4">
                                      Order Summary
                                    </h3>

                                    <div className="space-y-3">
                                      <div className="flex justify-between text-gray-600">
                                        <span>Subtotal</span>
                                        <span className="font-semibold text-black">
                                          {businessFee}
                                        </span>
                                      </div>
                                      <div className="flex justify-between text-gray-600">
                                        <span>Tax</span>
                                        <span className="font-semibold text-black">
                                          $0
                                        </span>
                                      </div>
                                      <hr />
                                      <div className="flex justify-between text-gray-900">
                                        <span className="font-semibold">
                                          Total
                                        </span>
                                        <span className="font-bold text-xl">
                                          {businessFee}
                                        </span>
                                      </div>
                                    </div>

                                    <p className="text-xs text-gray-500 mt-6">
                                      Verification is valid for 1 year. Annual
                                      re-verification required.
                                    </p>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ) : isInfluencerAccount ? (
                          <div>
                            <div className="space-y-4">
                              <div>
                                <label className="text-[14px] font-medium">
                                  Media Link 1 (Required)
                                </label>
                                <input
                                  type="text"
                                  placeholder="Enter media link (e.g., Instagram, YouTube, TikTok URL)"
                                  value={mediaLinkUrl1}
                                  onChange={(e) =>
                                    setMediaLinkUrl1(e.target.value)
                                  }
                                  className="mt-2 w-full h-[56px] px-4 border border-[#095228] rounded-xl text-[14px]"
                                />
                              </div>

                              <div>
                                <label className="text-[14px] font-medium">
                                  Media Link 2 (Required)
                                </label>
                                <input
                                  type="text"
                                  placeholder="Enter media link (e.g., Instagram, YouTube, TikTok URL)"
                                  value={mediaLinkUrl2}
                                  onChange={(e) =>
                                    setMediaLinkUrl2(e.target.value)
                                  }
                                  className="mt-2 w-full h-[56px] px-4 border border-[#095228] rounded-xl text-[14px]"
                                />
                              </div>

                              <div>
                                <label className="text-[14px] font-medium">
                                  Media Link 3 (Required)
                                </label>
                                <input
                                  type="text"
                                  placeholder="Enter media link (e.g., Instagram, YouTube, TikTok URL)"
                                  value={mediaLinkUrl3}
                                  onChange={(e) =>
                                    setMediaLinkUrl3(e.target.value)
                                  }
                                  className="mt-2 w-full h-[56px] px-4 border border-[#095228] rounded-xl text-[14px]"
                                />
                              </div>
                            </div>

                            <div className="flex justify-between items-center pt-6">
                              <button
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                  backgroundColor: isSubmitting
                                    ? "#747474"
                                    : "#095228",
                                }}
                                className="w-full max-w-[350px] text-white text-md py-3 px-6 rounded-full flex items-center justify-between transition-colors duration-300 hover:opacity-90 disabled:opacity-50"
                              >
                                {isSubmitting
                                  ? "Submitting..."
                                  : "Apply for Verification"}
                                <img
                                  src={verifyarrow}
                                  className="w-6 h-6"
                                  alt="arrow"
                                />
                              </button>
                            </div>
                          </div>
                        ) : null}
                      </form>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
